import { render, staticRenderFns } from "./character-card.vue?vue&type=template&id=f4c18030&scoped=true&"
import script from "./character-card.vue?vue&type=script&lang=ts&"
export * from "./character-card.vue?vue&type=script&lang=ts&"
import style0 from "./character-card.vue?vue&type=style&index=0&id=f4c18030&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c18030",
  null
  
)

export default component.exports